import * as React from 'react';
import {Menu} from "./Menu";
import styled from "styled-components";
import {WP_CONTENT_PREFIX} from "../constants";
import I18n from "../utils/i18n";
import {Background, Overlay} from "../styled-components/Overlay";


const TitleOverlay = styled.div`
    font-family: 'Pixel Coleco';
    text-align: center;
    color: #fed230;
    font-size: 2.5vh;
`;

const MouseChaseLogoOverlay = styled.img`
    width: 25vw;
    margin: 3vh 0;
`;

export class MenuOverlay extends React.Component {

    render() {
        const {closeMenuOverlay, musicPlaying, toggleMusicPlaying} = this.props;
        return (
            <Background>
                <Overlay>
                    <TitleOverlay>{I18n.translate('openingScreen')}</TitleOverlay>
                    <MouseChaseLogoOverlay src={`${WP_CONTENT_PREFIX}/images/opening_title.png`}/>
                    <Menu type="firstScreen" musicPlaying={musicPlaying} toggleMusicPlaying={toggleMusicPlaying} toggleHideOverlay={closeMenuOverlay}/>
                </Overlay>
            </Background>
        );
    }
}
